import React from "react";
import {Form, Select, Spin} from "antd";
import {HearAboutUsList} from "../../models/marketing/headAboutUs";

const Option = Select.Option;

class HearAboutUsForm extends React.Component {
  state = {
    visible: false,
    data: [],
    value: [],
    fetching: false
  };

  fetchHearAboutUs = (value = '') => {
    this.setState({data: [], fetching: true});
    const requestData = {'search': value};
    HearAboutUsList(requestData)
      .then(body => {
        const data = body.data.results.map(data => ({
          text: data.title,
          value: data.id
        }));
        this.setState({data, fetching: false});
      });
  };

  handleChange = value => {
    this.setState({
      value,
      data: [],
      fetching: false
    });
    this.props.onChange(value.key);
  };


  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this)
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {getFieldDecorator} = this.props.form;
    const {fetching, data, value} = this.state;
    return (
      <div className="pos-relative">
        <Select labelInValue showSearch value={value} placeholder="Select Hear About Us"
                notFoundContent={fetching ? <Spin size="small"/> : null} filterOption={false}
                onFocus={this.fetchHearAboutUs} onSearch={this.fetchHearAboutUs} onChange={this.handleChange}
                style={{width: "100%"}}>
          {data.map(d => (
            <Option key={d.value}>{d.text}</Option>
          ))}
        </Select>
      </div>
    );
  }
}

export const HearAboutUs = Form.create()(HearAboutUsForm);


// WEBPACK FOOTER //
// ./src/filters/marketing/HearAboutUs.jsx